import { render, staticRenderFns } from "./po-receipt.vue?vue&type=template&id=58300608&"
import script from "./po-receipt.vue?vue&type=script&lang=ts&"
export * from "./po-receipt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports